<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" />
    </el-form-item>
    <el-form-item label="自定义">
      <el-input disabled v-model="value.customize.name" size="small"
        :placeholder="value.customize.name == null ? '无' : value.customize.name">
        <template slot="append">
            <el-button @click="delCustomize" icon="el-icon-delete" size="small" style="border-right: 1px solid #e4e7ed; border-radius: 0;"></el-button>
            <el-button @click="openDialog" icon="el-icon-menu" size="small"></el-button>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="扫码录入">
      <el-switch v-model="value.enableScan"></el-switch>
    </el-form-item>
    <el-dialog title="选择数据源" :visible.sync="showCustomize" width="800px" append-to-body>
      <el-row>
        <el-col :md="4">
          <el-menu :default-active="menu" class="el-menu-vertical-demo" @select="handleSelect">
            <el-menu-item index="1">
              <span slot="title">当前数据</span>
            </el-menu-item>
            <el-menu-item index="2">
              <span slot="title">系统数据</span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :md="20">
          <el-row v-if="menu === '1'">
            <el-col :md="4">
              <div class="type">
                数据类型
              </div>
              <div class="type">
                选择数据
              </div>
            </el-col>
            <el-col :md="20">
              <el-tabs v-model="activeName" @tab-click="handleClick" style="border: none;">
                <el-tab-pane label="当前用户" name="first">
                  <span @click="currentClick" title="id" class="text1">当前用户id</span>
                  <span @click="currentClick" title="name" class="text1">当前用户姓名</span>
                  <span @click="currentClick" title="phoneNumber" class="text1">当前用户手机号码</span>
                  <span @click="currentClick" title="email" class="text1">当前用户邮箱</span>
                  <span @click="currentClick" title="postId" class="text1">当前用户岗位id</span>
                  <span @click="currentClick" title="postName" class="text1">当前用户岗位名称</span>
                  <span @click="currentClick" title="roleId" class="text1">当前用户角色id</span>
                  <span @click="currentClick" title="roleName" class="text1">当前用户角色名称</span>
                  <span @click="currentClick" title="deptId" class="text1">当前用户部门id</span>
                  <span @click="currentClick" title="deptName" class="text1">当前用户部门名称</span>
                  <span @click="currentClick" title="leader" class="text1">当前用户部门负责人</span>
                  <span @click="currentClick" title="parentName" class="text1">上级部门</span>
                  <span @click="currentClick" title="parentDeptLeader" class="text1">上级部门负责人</span>
                </el-tab-pane>
                <el-tab-pane label="当前公司" name="second">
                  <span @click="currentClick" title="partId" class="text1">当前公司id</span>
                  <span @click="currentClick" title="partName" class="text1">当前公司名称</span>
                  <span @click="currentClick" title="areaId" class="text1">当前公司所属区域id</span>
                  <span @click="currentClick" title="areaName" class="text1">当前公司所属区域名称</span>
                  <span @click="currentClick" title="partitionId" class="text1">当前公司所属分区id</span>
                  <span @click="currentClick" title="partitionName" class="text1">当前公司所属分区名称</span>
                  <span @click="currentClick" title="typeId" class="text1">当前公司类型id</span>
                  <span @click="currentClick" title="typeName" class="text1">当前公司类型名称</span>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
          <el-row v-if="menu === '2'">
            <el-row>
              <el-col :md="4">
                <div class="type">
                  父级控件
                </div>
              </el-col>
              <el-col :md="20">
                <el-select size="small" v-model="fieldId" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="4">
                <div class="type" style="margin-bottom: 50px;">
                  选择模块
                </div>
              </el-col>
              <el-col :md="20">
                <span @click="tClick" class="txt">单位</span>
                <!-- <span @click="tClick" class="txt">区域</span>
                <span @click="tClick" class="txt">分区</span> -->
                <span @click="tClick" class="txt">用户</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="4">
                <div class="type">
                  选择字段
                </div>
              </el-col>
              <el-col :md="20">
                <div v-if="model == '单位'">
                  <span @click="textClick" title="storeId" class="text2">部门所属单位id</span>
                  <span @click="textClick" title="part" class="text2">部门所属单位</span>
                  <span @click="textClick" title="area" class="text2">部门/单位所属区域</span>
                  <span @click="textClick" title="areaId" class="text2">部门/单位所属区域id</span>
                  <!-- <span @click="textClick" title="partition" class="text2">部门/单位/区域所属分区</span> -->
                </div>
                <!-- <div v-if="model == '区域'">
                  <span @click="textClick" title="areaId" class="text2">部门所属区域id</span>
                  <span @click="textClick" title="area" class="text2">部门/单位所属区域</span>
                  <span @click="textClick" title="partition" class="text2">部门/单位/区域所属分区</span>
                </div>
                <div v-if="model == '分区'">
                  <span @click="textClick" title="partition" class="text2">故障id</span>
                  <span @click="textClick" title="partition" class="text2">部门/单位/区域所属分区</span>
                </div> -->
                <div v-if="model == '用户'">
                  <span @click="textClick" title="id" class="text2">用户id</span>
                  <span @click="textClick" title="name" class="text2">用户姓名</span>
                  <span @click="textClick" title="deptId" class="text2">用户部门id</span>
                  <span @click="textClick" title="deptName" class="text2">用户部门名称</span>
                  <span @click="textClick" title="postId" class="text2">用户岗位id</span>
                  <span @click="textClick" title="postName" class="text2">用户岗位名称</span>
                  <span @click="textClick" title="roleId" class="text2">用户角色id</span>
                  <span @click="textClick" title="roleName" class="text2">用户角色名称</span>
                  <span @click="textClick" title="phoneNumber" class="text2">用户手机号</span>
                  <span @click="textClick" title="email" class="text2">用户邮箱</span>
                  <span @click="textClick" title="part" class="text2">用户所属单位</span>
                  <span @click="textClick" title="area" class="text2">用户所属区域</span>
                  <span @click="textClick" title="partition" class="text2">用户所属分区</span>
                </div>
              </el-col>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="confirm" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showCustomize: false,
      activeName: 'first',
      customize: null,
      id: null,
      model: null,
      menu: '1',
      fieldId: null,
      options: []
    }
  },
  created() {
    if (this.value.customize == undefined) {
      this.value.customize = {
        id: null,
        name: ''
      }
    }
  },
  mounted() {
    this.getOptions(this.$store.state.design.formItems)
  },
  methods: {
    getOptions(map) {
      map.forEach(e => {
        if (e.name == 'SpanLayout') {
          this.getOptions(e.props.items)
        } else if (e.name == 'TableList') {
          this.getOptions(e.props.columns)
        } else {
          this.options.push({
            value: e.id,
            label: e.title
          })
        }
      })
    },
    handleSelect(e) {
      this.menu = e
      this.fieldId = null
      this.customize = null
    },
    handleClick(e) {
      // console.log(e)
    },
    tClick(event) {
      const allTextSpans1 = document.querySelectorAll('.txt');
      const allTextSpans2 = document.querySelectorAll('.text2');
      // 移除所有 'text' 元素的 'clicked' 类
      this.removeClick(allTextSpans1)
      this.removeClick(allTextSpans2)
      this.customize = null
      this.model = event.target.innerText;
      event.target.classList.toggle('clicked');
    },
    textClick(event) {
      const allTextSpans = document.querySelectorAll('.text2');
      // 移除所有 'text' 元素的 'clicked' 类
      this.removeClick(allTextSpans)
      this.customize = event.target.innerText;
      this.id = event.target.getAttribute('title')
      event.target.classList.toggle('clicked');
    },
    currentClick(event) {
      const allTextSpans = document.querySelectorAll('.text1');
      // 移除所有 'text' 元素的 'clicked' 类
      this.removeClick(allTextSpans)
      this.customize = event.target.innerText;
      this.id = event.target.getAttribute('title')
      event.target.classList.toggle('clicked');
    },
    removeClick(allTextSpans) {
      allTextSpans.forEach(span => {
        span.classList.remove('clicked');
      });
    },
    openDialog() {
      this.showCustomize = true
    },
    delCustomize() {
      this.value.customize = {
        id: null,
        name: ''
      }
      this.value.fieldId = null
    },
    confirm() {
      if (this.customize == null && this.menu == '1') {
        return this.$message.error('请选择当前数据的具体字段')
      } else if (this.menu == '2') {
        if (this.fieldId == null) {
          return this.$message.error('请选择父组件内容')
        } else if (this.customize == null) {
          return this.$message.error('请选择系统数据模块')
        }
      }
      this.value.customize = {
        id: this.id,
        name: this.customize,
      }
      this.value.fieldId = this.fieldId
      this.showCustomize = false
      this.customize = null
    }
  }
}
</script>

<style scoped>
.type {
  margin: 10px 10px 30px 10px;
}

/*去下划线 */
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

::v-deep .el-tabs__item {
  padding: 0 20px !important;
}

::v-deep .el-tabs__item.is-active,
.el-tabs__item:hover {
  border: solid 1px #067b50;
  border-radius: 10px;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
  background-color: transparent !important;
}

.txt {
  cursor: pointer;
  display: inline-flex;
  padding: 5px 20px;
}

.text1, .text2 {
  cursor: pointer;
  display: inline-flex;
  padding: 5px 20px;
}

.clicked {
  border: solid 1px #067b50;
  border-radius: 10px;
  color: #067b50;
}

</style>
